var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('b-container',{staticClass:"my-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col",attrs:{"md":"6"}},[_c('CreditCard')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }